import { setAuthorization } from './general';

export const login = (credentials) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post('/api/login', credentials, {
        timeout: 3000,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content'),
        },
      })
      .then((response) => {
        setAuthorization(response.data.access_token);
        resolve(response.data);
      })
      .catch(() => {
        // if (error.response.status == 422) {
        //   reject(error.response.data.errors);
        // }
        reject('Incorrect email or password');
      });
  });
};

export const logout = () => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(
        '/api/logout',
        {},
        {
          timeout: 3000,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': document
              .querySelector('meta[name="csrf-token"]')
              .getAttribute('content'),
          },
        }
      )
      .then(() => {
        resolve();
      })
      .catch(() => {
        // if (error.response.status == 422) {
        //   reject(error.response.data.errors);
        // }
        reject('The server had an error');
      });
  });
};

export const register = (credentials) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post('/api/register', credentials, {
        timeout: 3000,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content'),
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        if (error.response.status == 422) {
          reject(error.response.data.errors);
        }
        reject(error);
      });
  });
};

export const reset = (credentials) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post('/api/password/reset', credentials, {
        timeout: 3000,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-TOKEN': document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content'),
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        if (error.response.status == 422) {
          reject(error.response.data.errors);
        }
        reject(error);
      });
  });
};

export const email = (credentials) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post('/api/password/email', credentials, {
        timeout: 3000,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-TOKEN': document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content'),
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        if (error.response.status == 422) {
          reject(error.response.data.errors);
        }
        reject(error);
      });
  });
};
